import { useMeetingManager } from 'amazon-chime-sdk-component-library-react';
import { useEffect, useState } from 'react';
import { useVideoConfig } from '../video-config-provider';
export const InitMeeting = ({ children }) => {
    const meetingManager = useMeetingManager();
    const { data } = useVideoConfig();
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        initMeeting(data);
        return () => {
            meetingManager.leave();
        };
    }, []);
    const initMeeting = async ({ Attendee, Meeting }) => {
        await meetingManager.join({
            meetingInfo: Meeting,
            attendeeInfo: Attendee,
        });
        await meetingManager.start();
        setLoading(false);
    };
    return loading ? null : children;
};
//# sourceMappingURL=init-meeting.js.map